export default "__VITE_ASSET__7d57780a__"